// extracted by mini-css-extract-plugin
export default {"chips":"Chips_chips__LQk1e","chip":"Chips_chip__2wj8p","n":"Chips_n__a9YAT"};